<template>
  <div
    v-if="filtersWithoutTextFilters.length"
    class="filter-wrapper__filter-history"
    :class="{ 'margin-x-8': mode === 'DESKTOP' }"
  >
    <!-- <div class="filter-wrapper__navigation">
      <div
        v-if="rightNavigation"
        class="filter-wrapper__navigation-item filter-wrapper__navigation-item--right"
        @click="slide('right')"
      >
        <mdicon name="chevron-right" size="16" />
      </div>
      <div
        class="filter-wrapper__navigation-item filter-wrapper__navigation-item--left"
        @click="slide('left')"
      >
        <mdicon name="chevron-left" size="16" />
      </div>
    </div> -->
    <div
      class="filter-wrapper__filter-history-items"
      ref="filterSlider"
      style="scroll-snap-type: x mandatory; overflow-x: auto"
    >
      <div
        class="filter-wrapper__filter-history-item"
        v-for="({ id, caption, count }, index) in filtersWithoutTextFilters"
        :key="`b-${index}`"
        @click.stop="showFilter(id)"
      >
        <span class="filter-wrapper__filter-history-text">
          {{ caption }}
        </span>
        <span v-if="count" class="chips chips--primary chips--pill">
          {{ count }}
        </span>
        <span
          class="filter-wrapper__filter-history-icon flex margin-right-8 color-error"
          @click.stop="handleRemoveFilter(id)"
        >
          <mdicon class="icon-default" name="close" size="24" />
          <mdicon class="icon-hovered" name="close-circle" size="24" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, toRefs } from "vue";
import { includes } from "ramda";
export default {
  props: {
    filters: {
      type: Array,
      default: () => [],
    },
    textFilters: {
      type: Array,
      default: () => [],
    },
    removeFilter: {
      type: Function,
      default: () => {},
    },
    mode: {
      type: String,
      default: "DESKTOP",
    },
  },
  setup(props, { emit }) {
    // generate props data
    const { filters, textFilters } = toRefs(props);

    const filtersWithoutTextFilters = computed(() => {
      // remove search text filters
      let newFilters = filters.value.filter((filter) => {
        const { id } = filter;
        const textFiltersId = textFilters.value.map((item) => item.key_service);
        return !includes(id, textFiltersId);
      });

      // add loading key to new filters
      newFilters = newFilters.map((newFilter) => {
        const filterValue = newFilter.value;
        const filterType = newFilter.type;
        const count =
          Array.isArray(filterValue) && filterType === "checkbox_multiselect"
            ? filterValue.length
            : 0;
        return { ...newFilter, loading: false, count };
      });

      return newFilters;
    });

    // handle slider code
    const rightNavigation = ref(false);
    const filterSlider = ref(null);
    const slide = (direction) => {
      // handle filter history slider
      if (direction === "left") {
        filterSlider.scrollLeft -= 200;
      } else {
        filterSlider.scrollLeft += 200;
      }
      rightNavigation.value = !!filterSlider.scrollLeft;
    };

    // remove a filter
    const handleRemoveFilter = async (id) => {
      await props.removeFilter(id);
    };

    // show filter
    const showFilter = (id) => {
      emit("showFilter", id);
    };

    // return data to be used in template
    return {
      includes,
      filtersWithoutTextFilters,
      rightNavigation,
      filterSlider,
      slide,
      handleRemoveFilter,
      showFilter,
    };
  },
};
</script>
